export default __webpack_public_path__ + "static/media/WordWork_11.cc7a571f.png";